import './NavPage.scss';
import React from 'react';
import PropTypes from 'prop-types';
/* eslint no-unused-vars: [2, { "varsIgnorePattern": "[CssConstants]" }] */
import CssConstants from 'style/CssConstants';
import StatefulNavBar from 'components/nav/StatefulNavBar';
import SitewideNotification from 'components/nav/SitewideNotification';
import StatefulFooter from 'components/layout/shared/StatefulFooter';
import IdentityStatus from 'components/shared/IdentityStatus';
import { AjaxErrorBoundary as ErrorBoundary } from 'components/shared/ErrorBoundary';
import Page from '../../../shared/components/Page';

class NavPage extends Page {
  static propTypes = {
    children: PropTypes.node,
    hideJoinLink: PropTypes.bool,
    renderWhiteBackground: PropTypes.bool,
    dismissIdentityStatus: PropTypes.bool,
  };

  static childContextTypes = {
    handleNavMenuChange: PropTypes.func,
  };

  static defaultProps = {
    renderWhiteBackground: false,
  };

  constructor(props) {
    super(props);
    this.state = {
      ...super.state,
      isNavMenuOpen: false,
      dismissIdentityStatus: this.props.dismissIdentityStatus || false,
    };
  }

  getChildContext() {
    return {
      handleNavMenuChange: function (event) {
        this.setState({ isNavMenuOpen: event.type === 'show' });
      }.bind(this),
    };
  }

  render() {
    const { children, hideJoinLink, renderWhiteBackground } = this.props;
    const {
      showToaster, isNavMenuOpen, dismissIdentityStatus,
    } = this.state;
    const aaWrapperClass = showToaster ? 'aa-wrapper-blur' : 'aa-wrapper';
    const contentWrapperClass = isNavMenuOpen ? 'aa-content-blur' : '';

    const backgroundColor = renderWhiteBackground
      ? CssConstants.COLOR_WHITE : CssConstants.COLOR_AA_BACKGROUND;

    return (
      <div className="nav-page">
        <div className={aaWrapperClass}>
          <div className="aa-page" style={{ backgroundColor }}>
            <StatefulNavBar hideJoinLink={hideJoinLink} isNavMenuOpen={isNavMenuOpen} />
            <SitewideNotification />
            <div className={contentWrapperClass}>
              {
                !dismissIdentityStatus
                && <IdentityStatus />
              }
              <ErrorBoundary>
                {children}
              </ErrorBoundary>
            </div>
            <div className="push" />
          </div>
          <div className={contentWrapperClass}>
            <StatefulFooter backgroundColor={backgroundColor} />
          </div>
        </div>
        {this.renderToaster()}
      </div>
    );
  }
}

export default NavPage;
